import React from "react";

const ContactSpin = () => {
  return (
    <ul>
      <li>
        Developer name: <span>Nigam Dudhat</span>
      </li>
      <li>
        By email:{" "}
        <a
          href="mailto:nigamdudhat2024@gmail.com"
          class="__cf_email__"
          target="_blank"
          rel="noopener noreferrer"
        >
          nigamdudhat2024@gmail.com
        </a>
      </li>
    </ul>
  );
};

export default ContactSpin;
